import { useTranslation } from 'react-i18next';
import { MemberRow } from './MemberRow';
import type { MembersPageProps } from './membersPageProps';
import type { OrgMember } from '../../services/org.service';

interface MembersTableProps extends MembersPageProps {
  filteredMembers: OrgMember[];
  members: OrgMember[];
}

export function MembersTable({ filteredMembers, members, selfUid, toggling, onToggleDisabled, roles, onChangeRole }: MembersTableProps) {
  const { t } = useTranslation();
  const activeAdmins = members.filter(m => m.role === 'admin' && !m.isDisabled);
  const isLastActiveAdmin = activeAdmins.length === 1;

  return (
    <table className="hidden w-full sm:table">
      <thead>
        <tr className="border-b border-green-200 bg-gray-50">
          <th className="px-4 py-3 text-start font-body text-xs font-semibold uppercase tracking-wider text-gray-600">
            {t('members.colName')}
          </th>
          <th className="px-4 py-3 text-start font-body text-xs font-semibold uppercase tracking-wider text-gray-600">
            {t('members.colEmail')}
          </th>
          <th className="px-4 py-3 text-start font-body text-xs font-semibold uppercase tracking-wider text-gray-600">
            {t('members.colRole')}
          </th>
          <th className="px-4 py-3 text-start font-body text-xs font-semibold uppercase tracking-wider text-gray-600">
            {t('members.colStatus')}
          </th>
          <th className="px-4 py-3 text-end font-body text-xs font-semibold uppercase tracking-wider text-gray-600">
            {t('members.colActions')}
          </th>
        </tr>
      </thead>
      <tbody>
        {filteredMembers.map((member: OrgMember, index: number) => (
          <MemberRow
            key={member.uid}
            member={member}
            isSelf={member.uid === selfUid}
            isToggling={toggling[member.uid] ?? false}
            onToggleDisabled={onToggleDisabled}
            isLast={index === filteredMembers.length - 1}
            isLastActiveAdmin={isLastActiveAdmin && member.role === 'admin' && !member.isDisabled}
            roles={roles}
            onChangeRole={onChangeRole}
          />
        ))}
      </tbody>
    </table>
  );
}
